import styled from 'styled-components';

export const ContentContainer = styled.div`
  margin: 0;
  font-size: 1.3rem;
`;
